import {
  Code2,
  Cog,
  Link2,
  MonitorSmartphone,
  MessagesSquare,
} from 'lucide-react';

const services = [
  {
    icon: Code2,
    title: 'Software sob medida',
    description:
      'Desenvolvemos sistemas personalizados que se encaixam perfeitamente na realidade do seu negócio.',
  },
  {
    icon: Cog,
    title: 'Automação de processos',
    description:
      'Eliminamos tarefas repetitivas e manuais, liberando seu time para o que realmente importa.',
  },
  {
    icon: Link2,
    title: 'Integração de sistemas e APIs',
    description:
      'Conectamos suas ferramentas e plataformas para que tudo funcione em sincronia.',
  },
  {
    icon: MonitorSmartphone,
    title: 'Sistemas web e back-end',
    description:
      'Criamos aplicações web robustas, seguras e preparadas para escalar com o seu crescimento.',
  },
  {
    icon: MessagesSquare,
    title: 'Consultoria em tecnologia',
    description:
      'Orientamos decisões técnicas estratégicas para que você invista com inteligência.',
  },
];

export function Services() {
  return (
    <section id="servicos" className="bg-card py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-6">
        <div className="text-center">
          <p className="text-sm font-semibold uppercase tracking-widest text-accent">
            Serviços
          </p>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-foreground sm:text-4xl text-balance">
            Soluções para cada desafio digital
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
            Da estratégia ao código, entregamos tudo o que você precisa para
            transformar sua operação.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => (
            <div
              key={service.title}
              className="group rounded-xl border border-border bg-background p-6 transition-all hover:border-accent/40 hover:shadow-md"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary text-primary-foreground transition-colors group-hover:bg-accent group-hover:text-accent-foreground">
                <service.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-5 font-heading text-lg font-semibold text-foreground">
                {service.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
